<template>
  <div class="test-page">
    <div style="height: 200px; background-color: red"></div>
    <input type="text" @focus="onFocus" @blur="onBlur"/>
    <div>window.innerHeight: {{innerHeight}}</div>
    <div>keyboardHeight: {{keyboardHeight}}</div>
    <div class="bottom" :style="{bottom: keyboardHeight+'px'}">
        bottom
    </div>
    <div ref="bottom" style="height: 1px;background: green; position: absolute; bottom: -1px; width: 100%"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      innerHeight: window.innerHeight,
      keyboardHeight: 0
    };
  },
  mounted(){
    // setTimeout(() => {
    //   window.scrollTo(0, 400)

    // }, 3000)  
  },
  methods: {
    onFocus() {
      this.innerHeight = 'onFocus: ' + window.innerHeight;
      
      let totalHeight = window.innerHeight
    //   let ref = this.$refs.bottom
    //     ref.scrollIntoView(false)
      setTimeout(() => {
        let ref = this.$refs.bottom
        ref.scrollIntoView(false)
        let scrollTop = document.scrollingElement.scrollTop || document.scrollingElement.scrollTop
        setTimeout(() => window.scrollTo(0,0))
        // window.scrollTo(0,0)
        console.log('scrollTop: ', scrollTop)
        // console.log('height: ', totalHeight- scrollTop)
        this.keyboardHeight = totalHeight - scrollTop
      }, 100)
    
    },
    onBlur() {
      this.innerHeight = 'onBlur: '  + window.innerHeight;
      this.keyboardHeight = 0
    }
  },
};
</script>

<style lang='less' scoped>
.test-page {
    // overflow-x: hidden;
    overflow-x:hidden;
    -webkit-overflow-scrolling:touch;
    // overflow-y: hidden;
  height: 100%;

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    // height: 50px;
    background: red;
    color: #fff;
    padding: 50px 0;
  }
}
</style>